import React from 'react';
import { Icon, IconNames, CUIText } from '@dotcom/crown-ui';
import styles from '../recipient-addresses-dialog.module.scss';
import { EditButton } from './edit-button';

export const DetailRecipients = ({
  shouldEdit,
  shouldShowBorderBottom,
  iconName,
  iconTestId,
  description,
  amount,
  onEditButtonClick = () => {
    return;
  },
}: {
  shouldEdit?: boolean;
  iconName: IconNames;
  iconTestId?: string;
  description: string;
  amount: number;
  onEditButtonClick?: () => void;
  shouldShowBorderBottom?: boolean;
}) => {
  return (
    <div className={`${styles.detailRecipientsContainer} ${shouldShowBorderBottom ? styles.borderBottom : ''}`}>
      <div className={styles.detail}>
        <Icon name={iconName} color={'dark-gray'} testId={iconTestId} />
        <CUIText as="label" className={styles['text']} color="textPrimary">
          {description}
          <CUIText as="span" className={styles['quantity']} color="textPrimary">
            {amount}
          </CUIText>
        </CUIText>
      </div>
      {shouldEdit && <EditButton onEditButtonClick={onEditButtonClick} />}
    </div>
  );
};
